/* Farah – the terms checkbox is hidden by design; keep it ticked so Kalles never blocks checkout */
(function () {
  function tick() { document.querySelectorAll('[data-agree-checkbox]').forEach(function (c) { c.checked = true; }); }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[name="checkout"], .t4s-btn__checkout, a[href*="/checkout"], button[type="submit"]')) tick();
  }, true);
  document.addEventListener('submit', tick, true);
  new MutationObserver(tick).observe(document.documentElement, { childList: true, subtree: true });
  tick();
})();
